import { FPlusEditorOptions, type ThemeType } from '@festina-life/fplus-monaco'
import { editor } from 'monaco-editor'

import { languageID } from '../../worker/FPlusConfiguration'

export const relayoutEditor = (
  monacoEditor: editor.IStandaloneCodeEditor,
  divNode: HTMLElement,
) => {
  const editorElement = monacoEditor.getDomNode()

  if (!editorElement) {
    return
  }

  const lineHeight = monacoEditor.getOption(editor.EditorOption.lineHeight)
  const lineCount = monacoEditor.getModel()?.getLineCount() || 1
  const height = lineHeight * lineCount

  divNode.style.height = `${height}px`
  monacoEditor.layout()
}

export const createEditor = ({
  node,
  theme,
  startingValue,
  options,
}: {
  node: HTMLElement
  theme: ThemeType
  startingValue?: string | undefined
  options?: editor.IStandaloneEditorConstructionOptions
}): editor.IStandaloneCodeEditor =>
  editor.create(node, {
    value: startingValue,
    theme,
    language: languageID,
    quickSuggestionsDelay: 500,
    automaticLayout: true,
    ...FPlusEditorOptions,
    ...options,
  })
